export default __webpack_public_path__ + "static/media/logo.8d0bd55d.svg";